
































































































































































import {Vue, Component, Prop, Emit} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";

@Component({})
export default class ObjektiCard2TabDodatno extends mixins(ComponentBaseMixin) {
    @Prop() store!: {};
    @Prop() storeTypes!: [];
    @Prop() storeCategories!: [];
    @Prop() chains!: [];
    @Prop() users!: [];
    @Prop() suppliers!: [];
    @Prop({default: false}) isBusySave!: boolean;

    @Emit() newStore() {
    }

    @Emit() saveStore() {

    }

}
